module.exports = __webpack_public_path__ + "static/img/5.867b9e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/5.png
// module id = 4zTq
// module chunks = 0